module.exports = __webpack_public_path__ + "img/main-menu.66059374.png";